// @flow

import React from 'react';
import { string } from 'prop-types';

const CategorizationSlot = ({ category }: { category: { title: string } }) => {
  if (!category) {
    return '';
  }
  return (
    <div className="categories">
      <a className="categorization-item" href="#" title={category.title}>
        {category.title}
      </a>
    </div>
  );
};

CategorizationSlot.propTypes = {
  subjects: string,
};

export default CategorizationSlot;
